/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {ConditionIfStepDTO} from './conditionIfStepDTO';
import {DelayStepDTO} from './delayStepDTO';
import {EmailStepDTO} from './emailStepDTO';
import {MarketingScenarioProcess} from './marketingScenarioProcess';
import {SaveQueryStepDTO} from './saveQueryStepDTO';
import {SmsStepDTO} from './smsStepDTO';
import {TransactionalScenarioProcess} from './transactionalScenarioProcess';

export interface ScenarioDTO {
    scenarioId?: string;
    name?: string;
    description?: string;
    affiliateCode?: string;
    owner?: string;
    affectedPartners?: Array<string>;
    icon?: string;
    type?: ScenarioDTO.TypeEnum;
    latestPublishedVersion?: number;
    versionId?: string;
    version?: number;
    process?: MarketingScenarioProcess | TransactionalScenarioProcess;
    statusScenario?: ScenarioDTO.StatusScenarioEnum;
    statusScenarioChangedAt?: Date;
    statusVersion?: ScenarioDTO.StatusVersionEnum;
    createdAt?: Date;
    updatedAt?: Date;
    steps?: Array<ConditionIfStepDTO | EmailStepDTO | SmsStepDTO | DelayStepDTO | SaveQueryStepDTO>;
    testEmails?: string[];
    allowMultipleEnrollments?: boolean;
    recordSaleCost?: boolean;
}
export namespace ScenarioDTO {
    export type TypeEnum = 'MARKETING' | 'TRANSACTIONAL';
    export const TypeEnum = {
        MARKETING: 'MARKETING' as TypeEnum,
        TRANSACTIONAL: 'TRANSACTIONAL' as TypeEnum
    };
    export type StatusScenarioEnum = 'IN_PROGRESS' | 'ON_PAUSE' | 'STOPPED' | 'ARCHIVE';
    export const StatusScenarioEnum = {
        INPROGRESS: 'IN_PROGRESS' as StatusScenarioEnum,
        ONPAUSE: 'ON_PAUSE' as StatusScenarioEnum,
        STOPPED: 'STOPPED' as StatusScenarioEnum,
        ARCHIVE: 'ARCHIVE' as StatusScenarioEnum
    };
    export type StatusVersionEnum = 'DRAFT' | 'PUBLISH' | 'STOPPED';
    export const StatusVersionEnum = {
        DRAFT: 'DRAFT' as StatusVersionEnum,
        PUBLISH: 'PUBLISH' as StatusVersionEnum,
        STOPPED: 'STOPPED' as StatusVersionEnum
    };
}
